export const CHAT_CHANGE_TYPE = {
  EDITED: 'edited',
  DELETED: 'deleted',
  REACTION_CHANGED: 'reaction_changed',
} as const;

export type ChatChangeType = (typeof CHAT_CHANGE_TYPE)[keyof typeof CHAT_CHANGE_TYPE];
